import React from 'react';
import Logo from '../../header/images/logo.png';

const MenuPlans = ({ onBack }) => {
  return (
    <div style={{
      width: '100%',
      background: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 32px',
      height: 80,
      position: 'relative',
      zIndex: 20
    }}>
      <img src={Logo} alt="ContaLearn" style={{ height: 54, cursor: 'pointer' }} onClick={() => window.location.href = '/'} />
      <button
        onClick={onBack || (() => window.history.length > 1 ? window.history.back() : window.location.assign('/viewplans'))}
        style={{
          background: 'linear-gradient(to right, #16c79e, #0a795f)',
          color: '#fff',
          border: 'none',
          borderRadius: 18,
          padding: '12px 32px',
          fontWeight: 700,
          fontSize: 18,
          boxShadow: '0 2px 8px rgba(22,199,158,0.08)',
          cursor: 'pointer',
          transition: 'background 0.2s, transform 0.2s',
          marginRight: 8
        }}
      >
        Înapoi
      </button>
    </div>
  );
};

export default MenuPlans;
